import baseRoute from '../baseRoute';

type RouteDefinition = `${typeof baseRoute}/${number | ':jobId'}/directoryId/${number | ':directoryId'}`;

export const ROUTE: RouteDefinition = `${baseRoute}/:jobId/directoryId/:directoryId`;

export const URL = (jobId: number, directoryId: number): RouteDefinition => `${baseRoute}/${jobId}/directoryId/${directoryId}`;
